// extracted by mini-css-extract-plugin
export default {"switch":"switch___LIcDRgO","disabled":"disabled___LIcDRgO","control":"control___LIcDRgO","text":"text___LIcDRgO","checked":"checked___LIcDRgO","label":"label___LIcDRgO"};